var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1250"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1250"
    },
    "bundlingPackage": "payments-ui-app",
    "bundlingPackageVersion": "static-1.28402",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};